var map = {
	"./alarm.png": "4c2b",
	"./anonymous.png": "d073",
	"./bar-chart.png": "4b7b",
	"./behavior.png": "b670",
	"./big-data.png": "4dda",
	"./checklist.png": "a1c5",
	"./computer.png": "24d5",
	"./cross-list.png": "80d3",
	"./data.png": "c883",
	"./document.png": "7bfd",
	"./documents.png": "5740",
	"./fraud.png": "9bc9",
	"./hand.png": "7fe9",
	"./leakage.png": "054b",
	"./monitor.png": "23e5",
	"./monitoring.png": "f121",
	"./notification.png": "a1fa",
	"./paper.png": "b86d",
	"./pricing.png": "fb3d",
	"./rank.png": "7ac9",
	"./ranking.png": "f92f",
	"./report-1.png": "021d",
	"./report.png": "daf8",
	"./scale.png": "fdd8",
	"./search-people.png": "f688",
	"./timeline.png": "26f6",
	"./transaccion.png": "8da9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "96d7";